import { useTranslation } from "@i18n/hooks";

import { BaseScreen } from "../../components/base-screen";

export const HomeScreen = () => {
	const { t } = useTranslation("common");

	return <BaseScreen>{t("home.welcome")}</BaseScreen>;
};
